





























































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'TableMenu',
})
export default class extends Vue {
  @Prop({}) public userunregister
  @Prop({}) public userNotAccessed
  public fieldsUnregister: any = [
    { key: 'no' },
    { key: 'salesmancode' },
    { key: 'salesmanname' },
    { key: 'possition' },
  ]
  public fieldsNotAccessed: any = [
    { key: 'no' },
    { key: 'salesmancode' },
    { key: 'salesmanname' },
    { key: 'possition' },
    { key: 'lastAccess' },
  ]
}
